export enum ProgressActionColor {
  'GREEN',
  'BLUE',
  'GRAY',
  'RED',
}
